export const setAgent = agent => {
    return {
        type: 'SET_AGENT',
        agent: agent
    }
};

